export default function formatSingularPlural(count = 0, singular: string, plural: string, excludeCount = false) {
  const term = count === 1 ? singular : plural;
  return excludeCount ? term : `${count} ${term}`;
}
